export enum DateFormat {
  DATE = 'YYYY-MM-DD',
  DATE_TIME = 'YYYY-MM-DD h:mm'
}
